// TODO: CONVERT TO TYPESCRIPT
import React from 'react'
import PropTypes from 'prop-types'

const Navigation = ({ shouldShowRecentPosts }) => {
  const renderLink = ({ title, anchor }) => (
    <li><a href={'#' + anchor}>{title}</a></li>
  )

  return (
    <ul className='vertical menu expanded' data-magellan style={{ marginTop: '46px' }}>
      {renderLink({ title: 'Overview', anchor: 'supplier-details' })}
      {renderLink({ title: 'Contract Vehicles', anchor: 'contract-vehicles' })}
      {shouldShowRecentPosts && renderLink({ title: 'Recent Posts', anchor: 'recent-posts' })}
      {renderLink({ title: 'Service Area', anchor: 'service-area' })}
      {renderLink({ title: 'Commodities', anchor: 'commodity-codes' })}
      {renderLink({ title: 'Reviews & Ratings', anchor: 'reviews' })}
    </ul>
  )
}

Navigation.propTypes = {
  shouldShowRecentPosts: PropTypes.bool
}

Navigation.defaultProps = {
  shouldShowRecentPosts: false
}

export default Navigation
